<a [routerLink]="['/product', productCode]"><div class="product-picture" [style.background-image]="pictureStyleUrl">&nbsp;</div></a>